import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import hoodie3d from "../assets/images/3dhood.png";

export default function Home3DBanner() {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      scale: [1, 1.06, 1],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: "easeInOut",
      },
    });
  }, [controls]);

  return (
    <section className="w-full bg-white py-10 px-4 md:px-16 flex items-center justify-center overflow-hidden">

      {/* LAYOUT CONTAINER */}
      <div className="relative flex flex-col sm:flex-row items-center justify-center w-full gap-4 sm:gap-10">

        {/* MOBILE TOP TEXT */}
        <h1
          className="
            sm:hidden 
            text-[50px] font-serif text-teal-800 select-none pointer-events-none
          "
        >
          Luxury
        </h1>

        {/* DESKTOP LEFT TEXT */}
        <h1
          className="
            hidden sm:block 
            text-[32px] md:text-[90px] lg:text-[110px] 
            font-serif text-teal-800 select-none pointer-events-none whitespace-nowrap
          "
        >
          Luxury
        </h1>

        {/* HOODIE IMAGE */}
        <motion.img
          src={hoodie3d}
          alt="DAXMA Hoodie"
          className="
            w-[240px] sm:w-[300px] md:w-[340px] lg:w-[380px] 
            z-10
          "
          animate={controls}
        />

        {/* MOBILE BOTTOM TEXT */}
        <h1
          className="
            sm:hidden 
            text-[50px] font-serif text-teal-800 select-none pointer-events-none
          "
        >
          Crafted
        </h1>

        {/* DESKTOP RIGHT TEXT */}
        <h1
          className="
            hidden sm:block 
            text-[32px] md:text-[90px] lg:text-[110px] 
            font-serif text-teal-800 select-none pointer-events-none whitespace-nowrap
          "
        >
          Crafted
        </h1>

      </div>

    </section>
  );
}
